module.exports = __webpack_public_path__ + "img/03-min.9d05f8d3.png";